import { useMutation, UseMutationOptions } from 'react-query';
import { PaymentsClient } from './payments-client';
import { StripeDashboardUrlData } from './payments-client/payments-client';

export const useStripeDashboardUrlMutation = (
  locationId?: string,
  options: UseMutationOptions<StripeDashboardUrlData> = {}
) => {
  const { mutateAsync, isLoading, error } = useMutation({
    mutationKey: PaymentsClient.queryKeys.getStripeDashboardUrlKey(locationId),
    mutationFn: () => PaymentsClient.getStripeDashboardUrl(locationId as string),
    ...options,
  });

  return {
    getDashboardLink: mutateAsync,
    isGettingDashboardLink: isLoading,
    dashboardLinkError: error,
  };
};
